<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			v-if="1 === 2"
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
		/>
		<feather-icon
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
export default {
	name: "CellRendererActions",
	computed: {
		getCheckedVisitPointsDelivery() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsDelivery;
		},
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup;
		},
	},
	methods: {
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("UploadFiles.DeleteUploadFile.Text1") +
					` "${this.params.data.bucket_path}"? ` +
					this.$t("UploadFiles.DeleteUploadFile.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store.commit("vehicle/REMOVE_UPLOAD_FILE_VEHICLE", this.params.data);
			this.$store.commit("vehicle/REMOVE_CHECKED_UPLOAD_FILE_VEHICLE", this.params.data);
		},
	},
};
</script>
<style lang="scss">
.button-undo {
	border-bottom: 2px solid;
	color: rgb(92, 91, 91);
	margin-left: 5px;
	font-weight: bold;
	cursor: pointer;
	font-size: 14px;
}
</style>
